import { ghElementSettingsDictionary } from './gh_element_settings_dictionary.js';
import { ghMenusDictionary } from './gh_menus_dictionary.js';
import { setViewTemplateDictionary } from './set_view_template_dictionary.js';
import { appsManagerDictionary } from './apps_manager_dictionary.js';

angular.module('localizationModule', [])

.service('localizationService', [function () {

  //********************* GET DICTIONARY ********************************//
  // * gh_element_settings — field settings panel labels (gh_element_settings_dictionary.js), used by fieldSettingsService
  // * gh_menus — shared labels for all context menus (gh_menus_dictionary.js), used by gh_view_editor_light_context_menu.js, gh_view_editor_context_menu.js, gh_view_context_menu.js
  // * set_view_template — view template layout names (set_view_template_dictionary.js), used by setViewTemplateService
  // * account_settings — apps list page labels (apps_manager_dictionary.js), used by ApplicationsCtrl
  const dictionaries = {
    gh_element_settings: ghElementSettingsDictionary,
    gh_menus: ghMenusDictionary,
    set_view_template: setViewTemplateDictionary,
    account_settings: appsManagerDictionary
  };

  this.getDictionary = function (dictionary_id) {
    return dictionaries[dictionary_id] || [];
  };

  //********************* TRANSLATE ********************************//
  // Translates a single word using the element's localization dictionary.
  // * word (string) — the original word to translate (e.g. element template name)
  // * dictionary (array) — localization entries from element.getDictionary(); may be null/undefined
  // Key is derived from the word itself (lowercase + underscores).
  // Always returns word as fallback — safe to call even if dictionary is missing or element has no localization().
  this.translate = function (word, dictionary) {
    try {
      const lang = gudhub.storage.getUser().language || 'en';
      const key = word.toLowerCase().replace(/ /g, '_');
      const entry = (dictionary || []).find(l => l.key === key);
      const translation = entry && (entry[lang] || entry.en);
      return translation || word;
    } catch (e) {
      return word;
    }
  };

  //********************* TRANSLATE TEMPLATE ********************************//
  // Translates name, field_name, and field_value properties of a getTemplate() result.
  // * template (object)  — full template object from element.getTemplate()
  // * dictionary (array) — localization entries from element.getDictionary(); may be null/undefined
  // Returns a new object — does not mutate the original. Non-string values are passed through unchanged.
  this.translateTemplate = function (template, dictionary) {
    const self = this;
    return Object.assign({}, template, {
      name: self.translate(template.name, dictionary),
      model: self.translateDataModel(template.model, dictionary)
    });
  };

  //********************* TRANSLATE DATA MODEL ********************************//
  // Translates the field_name property of a field data model object.
  // * dataModel (object)  — field model from element.getTemplate().model
  // * dictionary (array)  — localization entries from element.getDictionary(); may be null/undefined
  // Returns a new object — does not mutate the original.
  this.translateDataModel = function(dataModel, dictionary) {
    if (!dataModel) return dataModel;
    const self = this;
    const result = Object.assign({}, dataModel, {
      field_name: self.translate(dataModel.field_name, dictionary)
    });
    if (dataModel.data_model && Array.isArray(dataModel.data_model.options)) {
      result.data_model = Object.assign({}, dataModel.data_model, {
        options: dataModel.data_model.options.map(function(opt) {
          return Object.assign({}, opt, { name: self.translate(opt.name, dictionary) });
        })
      });
    }
    return result;
  };

  //********************* TRANSLATE TEMPLATES ********************************//
  // Translates the name property of each item in an array using the element's localization dictionary.
  // * templates (array)  — array of objects with a name property
  // * dictionary (array) — localization entries from element.getDictionary(); may be null/undefined
  // Returns a new array of shallow-cloned objects with translated names.
  this.translateTemplates = function (templates, dictionary) {
    const self = this;
    return templates.map(function (template) {
      const result = Object.assign({}, template);
      if (typeof result.name === 'string') result.name = self.translate(result.name, dictionary);
      if (typeof result.template_name === 'string') result.template_name = self.translate(result.template_name, dictionary);
      return result;
    });
  };

  //********************* TRANSLATE SETTINGS ********************************//
  // Translates header titles and ghElement field names inside settings tabs in-place.
  // * settings (array)      — tab settings from element.getSettings(); mutated directly
  // * dictionary (array)    — localization entries from element.getDictionary()
  // name_space is used as the translation key for field names.
  this.translateSettings = function (settings, dictionary) {
    const lang = gudhub.storage.getUser().language || 'en';
    const translate = (key) => {
    const entry = dictionary.find(l => l.key === key);
      return entry ? (entry[lang] || entry.en) : null;
    };

    settings.forEach(setting => {
      if (!setting.columns_list) return;
      setting.columns_list.forEach(column => {
        column.forEach(item => {
          if (item.type === 'header' && item.title) {
            item.title = translate(item.title.toLowerCase().replace(/ /g, '_')) || item.title;
          }
          if (item.type === 'ghElement' && item.data_model) {
            const original = item.data_model;
            item.data_model = function(fieldModel, appId) {
              const model = original.call(item, fieldModel, appId);
              if (model.name_space) {
                model.field_name = translate(model.name_space) || model.field_name;
              }
              return model;
            };
          }
        });
      });
    });

    return settings;
  };

}]);
